import React from 'react'
import './Services.css';

export default function Services() {
  return (
    <>
      <div className="service-page">
      <h1>Our Services</h1>
      <div className="service-list">
        <div className="service-item">
          <h2>Pramotion</h2>
          <p>
            We specialize in Pramoting your restorents and cafes and boost your reach.
          </p>
        </div>
        <div className="service-item">
          <h2>Exploring Ideas and places</h2>
          <p>
            We are always in searching and expanding the places presend in our webpage.
          </p>
        </div>
        <div className="service-item">
          <h2>Colabration</h2>
          <p>
            We have high intrest in Colabration with the clients.
          </p>
        </div>
        <div className="service-item">
          <h2>Inovation</h2>
          <p>
            intested in exploring new idea and various fields and expand continuously.
          </p>
        </div>
        <div className="service-item">
        <h2>Web Development</h2>
          <p>
            We specialize in creating responsive and dynamic web applications
            using modern technologies for your bussiness.
          </p>
        </div>
        <div className="service-item">
          <h2>SEO Optimization</h2>
          <p>
            Improve your website's visibility and rank higher on search engine
            results pages.
          </p>
        </div>
      </div>
    </div>
    </>
  )
}
